module.exports = __webpack_public_path__ + "img/haymarket_plugin.20cf7d14.png";